import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=869db9b4&"
import script from "./Fieldset.vue?vue&type=script&lang=ts&"
export * from "./Fieldset.vue?vue&type=script&lang=ts&"
import style0 from "./Fieldset.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports